export default __webpack_public_path__ + "static/media/kycVerificationhelpMobileHighlight@2x.ba902089.png";